export const applyFilterFacets = (options = [], facets, id, selected = []) => {
  if (!facets?.available?.[id] || !facets?.counts?.[id]) return options

  const selectedValues = new Set(Array.from(selected || [], String))
  const available = facets.available[id]
  const counts = facets.counts[id]

  return options
    .filter(
      (option) =>
        !option.value || Number(available[String(option.value)] || 0) > 0 || selectedValues.has(String(option.value)),
    )
    .map((option) => {
      if (!option.value) return option
      const value = String(option.value)
      const count = Number(counts[value] || 0)
      return {
        ...option,
        count,
        label: `${option.label} (${count})`,
        disabled: count === 0 && !selectedValues.has(value),
      }
    })
}

export const getFacetRequestKey = (params = {}) =>
  JSON.stringify(
    Object.entries(params || {})
      .filter(([key]) => !['page', 'perPage', 'includeFacets', 'sort', 'order'].includes(key))
      .sort(([a], [b]) => a.localeCompare(b)),
  )
